"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _orderViewConfigApi = require("@/api/orderViewConfigApi");
var _companyappApi = require("@/api/companyappApi");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ConfigTab',
  data: function data() {
    return {
      configList: [],
      loading: false,
      dialogVisible: false,
      dialogTitle: '新增配置',
      submitting: false,
      form: {
        id: null,
        appIds: [],
        viewDays: 30,
        enabled: true
      },
      rules: {
        viewDays: [{
          required: true,
          message: '请输入允许查看的天数',
          trigger: 'blur'
        }]
      },
      appOptions: []
    };
  },
  created: function created() {
    this.fetchConfigList();
    this.fetchAppOptions();
  },
  methods: {
    fetchConfigList: function fetchConfigList() {
      var _this = this;
      this.loading = true;
      (0, _orderViewConfigApi.getOrderViewConfigList)().then(function (res) {
        _this.configList = Array.isArray(res) ? res : [];
      }).catch(function (err) {
        console.error('获取配置列表失败:', err);
        _this.configList = [];
      }).finally(function () {
        _this.loading = false;
      });
    },
    fetchAppOptions: function fetchAppOptions() {
      var _this2 = this;
      (0, _companyappApi.companyappAutoListApi)().then(function (res) {
        var list = Array.isArray(res) ? res : [];
        _this2.appOptions = list;
      }).catch(function (err) {
        console.error('获取小程序列表失败:', err);
        _this2.appOptions = [];
      });
    },
    formatTime: function formatTime(time) {
      if (!time) return '--';
      var date = new Date(time);
      var pad = function pad(n) {
        return n < 10 ? '0' + n : n;
      };
      return "".concat(date.getFullYear(), "-").concat(pad(date.getMonth() + 1), "-").concat(pad(date.getDate()), " ").concat(pad(date.getHours()), ":").concat(pad(date.getMinutes()), ":").concat(pad(date.getSeconds()));
    },
    handleAdd: function handleAdd() {
      this.dialogTitle = '新增配置';
      this.form = {
        id: null,
        appIds: [],
        viewDays: 30,
        enabled: true
      };
      this.dialogVisible = true;
    },
    handleEdit: function handleEdit(row) {
      var _this3 = this;
      this.dialogTitle = '编辑配置';
      // 实时查询最新配置数据
      (0, _orderViewConfigApi.getOrderViewConfigDetail)(row.id).then(function (res) {
        _this3.form = {
          id: res.id,
          appIds: res.appIds || [],
          viewDays: res.viewDays === null || res.viewDays === undefined ? 30 : res.viewDays,
          enabled: res.enabled
        };
        _this3.dialogVisible = true;
      }).catch(function (err) {
        console.error('获取配置详情失败:', err);
        _this3.$message.error('获取配置详情失败');
      });
    },
    handleDelete: function handleDelete(row) {
      var _this4 = this;
      if (!row.id) return;
      this.$confirm('确认删除该配置？删除后关联的用户过滤也将一并清除。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _orderViewConfigApi.deleteOrderViewConfig)(row.id).then(function () {
          _this4.$message.success('删除成功');
          _this4.fetchConfigList();
        }).catch(function (err) {
          console.error('删除失败:', err);
          _this4.$message.error('删除失败：' + (err && err.message ? err.message : '未知错误'));
        });
      }).catch(function () {
        _this4.$message.info('已取消删除');
      });
    },
    handleSubmit: function handleSubmit() {
      var _this5 = this;
      this.$refs.form.validate(function (valid) {
        if (!valid) return;
        _this5.submitting = true;
        var requestData = {
          id: _this5.form.id || null,
          appIds: _this5.form.appIds.length > 0 ? _this5.form.appIds : null,
          viewDays: _this5.form.viewDays || 0,
          enabled: _this5.form.enabled
        };
        (0, _orderViewConfigApi.saveOrderViewConfig)(requestData).then(function () {
          _this5.$message.success('保存成功');
          _this5.dialogVisible = false;
          _this5.fetchConfigList();
        }).catch(function (err) {
          console.error('保存失败:', err);
          _this5.$message.error('保存失败：' + (err && err.message ? err.message : '未知错误'));
        }).finally(function () {
          _this5.submitting = false;
        });
      });
    },
    handleDialogClosed: function handleDialogClosed() {
      this.$refs.form.resetFields();
    }
  }
};